import none from '../../img/leoLogo.png'
import fruitygreen from '../../img/herbal/fruitygreen.jpg'
import minigreen from '../../img/herbal/mintigreen.jpg'

export const teaAndHerbal=[
    {
      "id": "131",
      "title": "چای ایرانی",
      "desciption": "",
      "price": "70",
      "image": none
    },
    {
      "id": "132",
      "title": "چای مخصوص لئو",
      "desciption": "",
      "price": "140",
      "image": none
    },
    {
      "id": "133",
      "title": "چای زعفران",
      "desciption": "",
      "price": "98",
      "image": none
    },
    {
      "id": "134",
      "title": "چای هل دارچین",
      "desciption": "",
      "price": "98",
      "image": none
    },
    {
      "id": "135",
      "title": "چای سبز",
      "desciption": "",
      "price": "120",
      "image": none
    },
    {
      "id": "136",
      "title": "چای ترش",
      "desciption": "",
      "price": "124",
      "image": none
    },
    {
      "id": "137",
      "title": "چای ماسالا چیلی",
      "desciption": "",
      "price": "134",
      "image": none
    },
    {
      "id": "138",
      "title": "به لیمو",
      "desciption": "",
      "price": "142",
      "image": none
    },
    {
      "id": "139",
      "title": "دمنوش آرامش",
      "desciption": "",
      "price": "130",
      "image": none
    },
    {
      "id": "1310",
      "title": "چای عسل لیمو",
      "desciption": "",
      "price": "134",
      "image": none
    },
    // {
    //   "id": "1311",
    //   "title": "چای+کروسان شکلاتی",
    //   "desciption": "",
    //   "price": "186",
    //   "image": none
    // },
    {
      "id": "1312",
      "title": "چای انگلیسی",
      "desciption": "چای سیاه شیرعسل دارچین",
      "price": "143",
      "image": none
    },
    {
      "id": "1313",
      "title": "دمنوش سرماخوردگی",
      "desciption": "آویشن-دارچین-زنجفیل-عسل",
      "price": "134",
      "image": none
    },
    {
      "id": "1314",
      "title": "دمنوش ویولت",
      "desciption": "تقویت معده",
      "price": "124",
      "image": none
    },
    {
      "id": "1315",
      "title": "دمنوش سیلونا",
      "desciption": "تسکین درد معده و آرامبخش",
      "price": "132",
      "image": none
    },
    {
      "id": "1316",
      "title": "بهارنارنج",
      "desciption": "",
      "price": "124",
      "image": none
    },
    {
      "id": "1317",
      "title": "بلوبری",
      "desciption": "",
      "price": "126",
      "image": none
    },
    {
      "id": "1318",
      "title": "چای ماسالا ساده",
      "desciption": "",
      "price": "132",
      "image": none
    },
    {
      "id": "1319",
      "title": "چای ماسالا با کره بادوم زمینی",
      "desciption": "",
      "price": "154",
      "image": none
    },
    {
      "id": "1320",
      "title": "دمنوش زعفران",
      "desciption": "ریشه زعفران-گل گاوزبان",
      "price": "140",
      "image": none
    },
    {
      "id": "1321",
      "title": "دمنوش کرن بری",
      "desciption": "",
      "price": "134",
      "image": none
    },
    {
      "id": "1322",
      "title": "دمنوش استوایی",
      "desciption": "",
      "price": "134",
      "image": none
    },
    {
      "id": "1323",
      "title": "دمنوش توت فرنگی",
      "desciption": "",
      "price": "134",
      "image": none
    },
    {
      "id": "1324",
      "title": "دمنوش سیب ترش",
      "desciption": "",
      "price": "134",
      "image": none
    },
    {
      "id": "1325",
      "title": "دمنوش جنسینگ",
      "desciption": "",
      "price": "144",
      "image": none
    },
    {
      "id": "1326",
      "title": "دمنوش رزماری",
      "desciption": "",
      "price": "140",
      "image": none
    },
    {
      "id": "1327",
      "title": "دمنوش دلخواه",
      "desciption": "",
      "price": "140",
      "image": none
    },
    {
      "id": "1328",
      "title": "mini green",
      "desciption": "چاي سبز+نعناع",
      "price": "155",
      "image": minigreen
    },
    {
      "id": "1329",
      "title": "fruity green",
      "desciption": "چاي سبز+نعناع",
      "price": "145",
      "image": fruitygreen
    },
    {
      "id": "1330",
      "title": " چای ترش فرنگی",
      "desciption": " ",
      "price": "154",
      "image": none
    },
    {
      "id": "1331",
      "title": "سرویس چای 2 نفره",
      "desciption": " ",
      "price": "170",
      "image": none
    },
    {
      "id": "1332",
      "title": "سرویس چای 4 نفره",
      "desciption": " ",
      "price": "290",
      "image": none
    },
  ]